import { BookingRequest, SiteAddress, SiteContactDetails } from "../../../APIDocs/apiTypes";
import { Model } from "../Model";
import { JobCommentsNode } from "../nodes/JobCommentsNode";
import { JobCommentsForWarrantNode } from "../nodes/JobCommentsForWarrantNode";
export class CompletionMessageFactory {

    public static MakeMessage(serviceLine: string): BookingRequest {
        const model = Model.GetModel();

        const siteType = model.Get("model.results.siteTypeCorrect") == true ? model.Get("viewModel.fetchedData.siteData.siteType") : model.Get("model.results.updatedSiteType")
        const jobTypeBooked: string = Model.GetModel().Get('viewModel.selectedJobKind');
        const isWarrantJob = jobTypeBooked?.toLowerCase().indexOf("warrant") > -1;
        const isForced = model.Get("model.forceOffersSelection") != undefined ? model.Get("model.forceOffersSelection") : "No";

        const dnoBnoCheckValue = model.Get("model.results.dnoBnoSiteInformation.exportCapacity") != undefined ? true : false;
        const isWindowJobBooking = model.Get("model.isWindowJobBooking") === "Yes";

        //Window job values
        const bookingType = isWindowJobBooking ? "windowBooking" : "booking";
        const startTime = isWindowJobBooking ? model.Get("model.windowBookingStartDate") : model.Get("model.results.offerSelected.startTime");
        const endTime = model.Get("model.results.offerSelected.endTime");
        const offerToken = isWindowJobBooking ? "" : model.Get("model.results.offerSelected.offerToken");

        let ramsRequired = false;
        let ramsEmail: string | undefined = undefined;

        if(model.Get("model.results.ramsRequired") == true) {
            ramsRequired = true;
            ramsEmail = model.Get("model.results.emailForRams");
        }

        const request: BookingRequest = {
            BookingType: bookingType,
            Forced: isForced,
            OfferToken: offerToken,
            StartTime: startTime,
            SiteType: siteType,
            JobType: model.Get("model.results.jobType"),
            RamsRequired: ramsRequired,
            RamsEmail: ramsEmail,
            SiteAddress: CompletionMessageFactory.getSiteAddressData(model),
            SiteContactDetails: CompletionMessageFactory.getSiteContactDetails(isWarrantJob, model),
            NotificationPreferences: CompletionMessageFactory.getNotificationPreferences(isWarrantJob, model),
            JobComments: CompletionMessageFactory.getJobComments(isWarrantJob),
            SiteDetails: {
                ParkingAvailable: true
            },
            ExtraSkills: model.Get("model.results.extraSkills"),
            RelatedBookingId: model.Get("model.results.relatedBookingId"),
            BookingReasonId: model.Get("model.results.bookingReasonId")
        }


        if(["DNO", "BNO"].includes(serviceLine) && dnoBnoCheckValue) {
            request.DnoBnoDetails = CompletionMessageFactory.getDnoBnoDetails(model);
        }

        if(!isWindowJobBooking) {
            request.EndTime = endTime;
            request.ScheduledDate = model.Get("model.results.offerSelected.scheduledDate");
            request.SpJobCode = model.Get("model.results.offerSelected.spJobCode");
        }

        return request;
    }

    private static getSiteAddressData = (model: Model): SiteAddress => {
        return {
            AddressName: model.Get("model.results.siteAddressDetails.siteName"),
            AddressLine1: model.Get("model.results.siteAddressDetails.line1"),
            AddressLine2: model.Get("model.results.siteAddressDetails.line2"),
            AddressLine3: model.Get("model.results.siteAddressDetails.line3"),
            Town: model.Get("model.results.siteAddressDetails.town"),
            County: model.Get("model.results.siteAddressDetails.county"),
            PostCode: model.Get("model.results.siteAddressDetails.postCode")
        }
    }

    private static getNotificationPreferences = (isWarrantJob: boolean, model: Model) => {
        if(!isWarrantJob) {
            return {
                SmsReminderRequested: model.Get("model.results.reminderSMSRequired"),
                EmailReminderRequested: model.Get("model.results.reminderEmailRequired"),
                SmsConfirmationRequested: model.Get("model.results.confirmationSMSRequired"),
                EmailConfirmationRequested: model.Get("model.results.confirmationEmailRequired"),
                NotificationSms: model.Get("model.results.confirmationSMSNumber"),
                NotificationEmail: model.Get("model.results.confirmationEmail")
            }
        } else {
            return {
                SmsReminderRequested: false,
                EmailReminderRequested: false,
                SmsConfirmationRequested: false,
                EmailConfirmationRequested: false,
                NotificationSms: undefined,
                NotificationEmail: undefined
            }
        }
    }

    private static getSiteContactDetails = (isWarrantJob: boolean, model: Model): SiteContactDetails => {
        if(!isWarrantJob) {
            return {
                Title: model.Get("model.results.siteContactDetails.title"),
                ContactFirstName: model.Get("model.results.siteContactDetails.firstname"),
                ContactSurname: model.Get("model.results.siteContactDetails.surname"),
                EmailAddress: model.Get("model.results.siteContactDetails.email"),
                ContactNumber: model.Get("model.results.siteContactDetails.number"),
                MobileNumber: model.Get("model.results.siteContactDetails.secondaryNumber")
            }
        } else {
            //below are the mapping for the 4 mandatory values for warrant job, they need dummied if they are not on the site return data.
            const title = model.Get("viewModel.fetchedData.siteContactDetails.title") != undefined ? model.Get("viewModel.fetchedData.siteContactDetails.title") : "Mx";
            const firstName = model.Get("viewModel.fetchedData.siteContactDetails.firstname") != undefined ? model.Get("viewModel.fetchedData.siteContactDetails.firstname") : "DummyCustName";
            const surname = model.Get("viewModel.fetchedData.siteContactDetails.surname") != undefined ? model.Get("viewModel.fetchedData.siteContactDetails.surname") : "DummyCustSurname";
            const contactNumber = model.Get("model.results.siteContactDetails.number") != undefined ? model.Get("model.results.siteContactDetails.number") : "00000000000";
            return {
                Title: title,
                ContactFirstName: firstName,
                ContactSurname: surname,
                ContactNumber: contactNumber,
                EmailAddress: model.Get("viewModel.fetchedData.siteContactDetails.email"),
            }
        }
    }

    private static getJobComments = (isWarrantJob: boolean) => {
        if(!isWarrantJob) {
            return JobCommentsNode.GetJobComments();
        } else {
            return JobCommentsForWarrantNode.GetJobComments();
        }
    }

    private static getDnoBnoDetails = (model: Model) => {
        return {
            ExportCapacity: model.Get("model.results.dnoBnoSiteInformation.exportCapacity"),
            ImportCapacity: model.Get("model.results.dnoBnoSiteInformation.importCapacity"),
            ServiceVoltage: model.Get("model.results.dnoBnoSiteInformation.serviceVoltage"),
            MeterPointVoltage: model.Get("model.results.dnoBnoSiteInformation.meterPointVoltage"),
            HvMetering: model.Get("model.results.dnoBnoSiteInformation.hvMetering") === "Yes" ? true : false,
            CtRatio: model.Get("model.results.dnoBnoSiteInformation.ctRatio"),
            VtRatio: model.Get("model.results.dnoBnoSiteInformation.vtRatio"),
            ServiceRating: model.Get("model.results.dnoBnoSiteInformation.serviceRating"),
            FuseSize: model.Get("model.results.dnoBnoSiteInformation.fuseSize"),
            CustomerOwnedSwitch: model.Get("model.results.dnoBnoSiteInformation.customerOwnedSwitch") === "Yes" ? true : false,
            PoNumber: model.Get("model.results.dnoBnoSiteInformation.poNumber")
        }
    }
}
